import { render, staticRenderFns } from "./JPFbPage.vue?vue&type=template&id=3031961c&scoped=true&"
var script = {}
import style0 from "./JPFbPage.vue?vue&type=style&index=0&id=3031961c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3031961c",
  null
  
)

export default component.exports